import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/legal/privacy-policy/global'

export const LEGAL_PRIVACY_POLICY_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
